import {InputBaseComponentProps} from '@material-ui/core';
import {EmptyString, NonEmptyString, StringUnion} from 'Core/models/EmptyString';
import React, {useState} from 'react';
import {Errors} from 'Shared/components/ErrorPopover';
import ValidatableTextField from 'Shared/components/ValidatableTextField';
import {removeUnsupportedSpecialChars} from 'Shared/utilities/regexUtility';

export type RequiredTextInputProps = {
  id?: string;
  value: StringUnion;
  onChange: (value: StringUnion) => void;
  label: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  multiline?: boolean;
  inputProps?: InputBaseComponentProps;
  limitSpecialChars?: boolean;
};

const RequiredTextInput = (props: RequiredTextInputProps) => {
  const [hasBeenBlurred, setHasBeenBlurred] = useState(false);

  const errors = Errors.standardErrors({
    value: (props.value instanceof EmptyString && ['Please supply a value.']) || [],
  });

  return (
    <ValidatableTextField
      multiline={props.multiline}
      label={props.label}
      placeholder={props.placeholder}
      disabled={props.disabled}
      errors={errors}
      showErrors={errors => hasBeenBlurred && errors.value.length > 0}
      className={props.className}
      onBlur={() => setHasBeenBlurred(true)}
      onChange={value =>
        props.limitSpecialChars === true
          ? props.onChange(NonEmptyString.create(removeUnsupportedSpecialChars(value)))
          : props.onChange(NonEmptyString.create(value))
      }
      inputProps={props.inputProps}
      value={props.value.value}
    />
  );
};

export default RequiredTextInput;
